import { render } from "./EmployeeApprovalsRejected.vue?vue&type=template&id=7a58a9c4"
import script from "./EmployeeApprovalsRejected.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovalsRejected.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__